import React from "react";
import type { FC, JSX, PropsWithChildren } from "react";

import ButtonsViewStack from "../../../Button/ButtonsView/components/Stack/ButtonsViewStack";

import type { ButtonsViewProps } from "../../../Button";

import classes from "./ToastButtonsView.styl";

const TOAST_BUTTONS_VIEW_TEST_ID = "toast-buttons-view-test-id";

export const ButtonsView: FC<PropsWithChildren<ButtonsViewProps>> = ({
    children,
    "data-tsid": tsid,
    ...props
}): JSX.Element => {
    return (
        <ButtonsViewStack
            {...props}
            data-tsid={TOAST_BUTTONS_VIEW_TEST_ID || tsid}
            view="horizontal"
            size="28"
            customVarsStyles={classes["buttons-view"]}
        >
            {children}
        </ButtonsViewStack>
    );
};

ButtonsView.displayName = "Toast.ButtonsView";

export default ButtonsView;
